module.exports = __webpack_public_path__ + "static/media/round-approved.0ae4a1f6.svg";